/**
 * A type-safe utility that creates a proxy object to capture property access
 * and convert it to a string literal type that can be used with react-hook-form.
 * 
 * @example
 * // Create a type-safe field accessor
 * const field = createFormField<MyType>();
 * 
 * // Use it with react-hook-form - this is type-safe and will error if 'title' is not a property of MyType
 * <Controller
 *   control={control}
 *   name={field.title}
 *   render={...}
 * />
 * 
 * // You can also use it with getValues, setValue, etc.
 * getValues(field.title)
 * setValue(field.title, 'new value')
 */
export function createFormField<T>(): { [K in keyof T & string]: K } {
  // Create a proxy object that captures property access
  return new Proxy(
    {} as { [K in keyof T & string]: K },
    {
      get: (target, prop) => {
        // Return the property name as a string
        return prop as any;
      }
    }
  );
}
